module.exports = __webpack_public_path__ + "public/SiteIcons/phoneInputClose.svg?dd88a164";